import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
  Upload: any;
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};


export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type Element = {
  __typename?: 'Element';
  active: Scalars['Boolean'];
  activeFrom?: Maybe<Scalars['DateTime']>;
  activeTo?: Maybe<Scalars['DateTime']>;
  bx_id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  detailPicture?: Maybe<File>;
  detailPicture_id?: Maybe<Scalars['String']>;
  detailText?: Maybe<Scalars['String']>;
  iblock?: Maybe<Iblock>;
  iblock_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modifiedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']>;
  previewPicture?: Maybe<File>;
  previewPicture_id?: Maybe<Scalars['String']>;
  previewText?: Maybe<Scalars['String']>;
  propertyValues: Array<PropertyValue>;
  propertyValuesEnum: Array<PropertyEnum>;
  propertyValuesRelation: Array<PropertyRelation>;
  sections: Array<Section>;
  seo?: Maybe<Seo>;
  seo_id?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  user_id?: Maybe<Scalars['String']>;
  user_id_modified?: Maybe<Scalars['String']>;
};


export type ElementPropertyValuesArgs = {
  after?: Maybe<PropertyValueWhereUniqueInput>;
  before?: Maybe<PropertyValueWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PropertyValueOrderByInput>>;
  where?: Maybe<PropertyValueWhereInput>;
};


export type ElementPropertyValuesEnumArgs = {
  after?: Maybe<PropertyEnumWhereUniqueInput>;
  before?: Maybe<PropertyEnumWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PropertyEnumOrderByInput>>;
  where?: Maybe<PropertyEnumWhereInput>;
};


export type ElementPropertyValuesRelationArgs = {
  after?: Maybe<PropertyRelationWhereUniqueInput>;
  before?: Maybe<PropertyRelationWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PropertyRelationOrderByInput>>;
  where?: Maybe<PropertyRelationWhereInput>;
};


export type ElementSectionsArgs = {
  after?: Maybe<SectionWhereUniqueInput>;
  before?: Maybe<SectionWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SectionOrderByInput>>;
  where?: Maybe<SectionWhereInput>;
};

export type ElementListRelationFilter = {
  every?: Maybe<ElementWhereInput>;
  none?: Maybe<ElementWhereInput>;
  some?: Maybe<ElementWhereInput>;
};

export type ElementOrderByInput = {
  active?: Maybe<SortOrder>;
  activeFrom?: Maybe<SortOrder>;
  activeTo?: Maybe<SortOrder>;
  bx_id?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  detailPicture_id?: Maybe<SortOrder>;
  detailText?: Maybe<SortOrder>;
  iblock_id?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  previewPicture_id?: Maybe<SortOrder>;
  previewText?: Maybe<SortOrder>;
  seo_id?: Maybe<SortOrder>;
  sort?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  user_id?: Maybe<SortOrder>;
  user_id_modified?: Maybe<SortOrder>;
};

export type ElementWhereInput = {
  AND?: Maybe<Array<ElementWhereInput>>;
  NOT?: Maybe<Array<ElementWhereInput>>;
  OR?: Maybe<Array<ElementWhereInput>>;
  active?: Maybe<BoolFilter>;
  activeFrom?: Maybe<DateTimeNullableFilter>;
  activeTo?: Maybe<DateTimeNullableFilter>;
  bx_id?: Maybe<IntNullableFilter>;
  code?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  createdBy?: Maybe<UserWhereInput>;
  detailPicture?: Maybe<FileWhereInput>;
  detailPicture_id?: Maybe<StringNullableFilter>;
  detailText?: Maybe<StringNullableFilter>;
  iblock?: Maybe<IblockWhereInput>;
  iblock_id?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  modifiedBy?: Maybe<UserWhereInput>;
  name?: Maybe<StringNullableFilter>;
  previewPicture?: Maybe<FileWhereInput>;
  previewPicture_id?: Maybe<StringNullableFilter>;
  previewText?: Maybe<StringNullableFilter>;
  propertyRelations?: Maybe<PropertyRelationListRelationFilter>;
  propertyValues?: Maybe<PropertyValueListRelationFilter>;
  propertyValuesEnum?: Maybe<PropertyEnumListRelationFilter>;
  propertyValuesRelation?: Maybe<PropertyRelationListRelationFilter>;
  sections?: Maybe<SectionListRelationFilter>;
  seo?: Maybe<SeoWhereInput>;
  seo_id?: Maybe<StringNullableFilter>;
  sort?: Maybe<FloatNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  user_id?: Maybe<StringNullableFilter>;
  user_id_modified?: Maybe<StringNullableFilter>;
};

export type ElementWhereUniqueInput = {
  bx_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  seo_id?: Maybe<Scalars['String']>;
};

export type File = {
  __typename?: 'File';
  ElementDetailPicture?: Maybe<Element>;
  ElementPreviewPicture?: Maybe<Element>;
  bx_id?: Maybe<Scalars['Int']>;
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  secret: Scalars['String'];
  size: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type FileWhereInput = {
  AND?: Maybe<Array<FileWhereInput>>;
  ElementDetailPicture?: Maybe<ElementWhereInput>;
  ElementPreviewPicture?: Maybe<ElementWhereInput>;
  NOT?: Maybe<Array<FileWhereInput>>;
  OR?: Maybe<Array<FileWhereInput>>;
  bx_id?: Maybe<IntNullableFilter>;
  contentType?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  propertyRelations?: Maybe<PropertyRelationListRelationFilter>;
  secret?: Maybe<StringFilter>;
  size?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  url?: Maybe<StringFilter>;
  user?: Maybe<UserWhereInput>;
};

export type FloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type Group = {
  __typename?: 'Group';
  User: Array<User>;
  bx_id?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type GroupUserArgs = {
  after?: Maybe<UserWhereUniqueInput>;
  before?: Maybe<UserWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type GroupListRelationFilter = {
  every?: Maybe<GroupWhereInput>;
  none?: Maybe<GroupWhereInput>;
  some?: Maybe<GroupWhereInput>;
};

export type GroupOrderByInput = {
  bx_id?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GroupWhereInput = {
  AND?: Maybe<Array<GroupWhereInput>>;
  NOT?: Maybe<Array<GroupWhereInput>>;
  OR?: Maybe<Array<GroupWhereInput>>;
  User?: Maybe<UserListRelationFilter>;
  bx_id?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GroupWhereUniqueInput = {
  bx_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export type Iblock = {
  __typename?: 'Iblock';
  active: Scalars['Boolean'];
  bx_id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  elements: Array<Element>;
  id: Scalars['String'];
  name: Scalars['String'];
  sections: Array<Section>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type IblockElementsArgs = {
  after?: Maybe<ElementWhereUniqueInput>;
  before?: Maybe<ElementWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ElementOrderByInput>>;
  where?: Maybe<ElementWhereInput>;
};


export type IblockSectionsArgs = {
  after?: Maybe<SectionWhereUniqueInput>;
  before?: Maybe<SectionWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SectionOrderByInput>>;
  where?: Maybe<SectionWhereInput>;
};

export type IblockWhereInput = {
  AND?: Maybe<Array<IblockWhereInput>>;
  NOT?: Maybe<Array<IblockWhereInput>>;
  OR?: Maybe<Array<IblockWhereInput>>;
  active?: Maybe<BoolFilter>;
  bx_id?: Maybe<IntNullableFilter>;
  code?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  elements?: Maybe<ElementListRelationFilter>;
  id?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  propertyEnums?: Maybe<PropertyEnumListRelationFilter>;
  sections?: Maybe<SectionListRelationFilter>;
  type?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};


export type Mutation = {
  __typename?: 'Mutation';
  createElement?: Maybe<Scalars['Boolean']>;
  flush?: Maybe<Scalars['Boolean']>;
  serviceClaimApiCreateClaim?: Maybe<Scalars['Json']>;
};


export type MutationCreateElementArgs = {
  bankNameValue?: Maybe<Scalars['String']>;
  branch_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  emailPropId?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Scalars['Upload']>>;
  iblockCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
};


export type MutationFlushArgs = {
  name: Scalars['String'];
};


export type MutationServiceClaimApiCreateClaimArgs = {
  AccidentTypeCode?: Maybe<Scalars['String']>;
  AddressDescription?: Maybe<Scalars['String']>;
  AddressStateCode?: Maybe<Scalars['String']>;
  Are2DetailsDamaged?: Maybe<Scalars['Boolean']>;
  BirthDate?: Maybe<Scalars['String']>;
  BuildingRgs?: Maybe<Scalars['String']>;
  BusinessUnitRgsCode?: Maybe<Scalars['String']>;
  CanSendSMS?: Maybe<Scalars['Boolean']>;
  CellPhone?: Maybe<Scalars['String']>;
  Citizenship?: Maybe<Scalars['String']>;
  ContactDocumentDate?: Maybe<Scalars['String']>;
  ContactDocumentType?: Maybe<Scalars['String']>;
  CorrelationId?: Maybe<Scalars['String']>;
  CountryCode?: Maybe<Scalars['String']>;
  CoverTypeCode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DirectOSAGO?: Maybe<Scalars['Boolean']>;
  DocumentIDNumberRgs?: Maybe<Scalars['String']>;
  DocumentIDSeriesRgs?: Maybe<Scalars['String']>;
  DocumentIssuer?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FalseDocumentsRgs?: Maybe<Scalars['Boolean']>;
  FirstMonthLossRgs?: Maybe<Scalars['Boolean']>;
  Firstname?: Maybe<Scalars['String']>;
  FraudSuspectedRgs?: Maybe<Scalars['Boolean']>;
  GBDDDocumentedRgs?: Maybe<Scalars['Boolean']>;
  Gender?: Maybe<Scalars['String']>;
  GuiltyLicensePlateUp?: Maybe<Scalars['String']>;
  GuiltyPolicyNumber?: Maybe<Scalars['String']>;
  GuiltyPolicySeries?: Maybe<Scalars['String']>;
  GuiltyRegistrationDateRgs?: Maybe<Scalars['DateTime']>;
  GuiltyRegistrationYear?: Maybe<Scalars['Float']>;
  GuiltyVINRequired?: Maybe<Scalars['Boolean']>;
  GuiltyVehicleBodyNumber?: Maybe<Scalars['String']>;
  GuiltyVehicleEnginePowerRgs?: Maybe<Scalars['Float']>;
  GuiltyVehicleMakeRgsCode?: Maybe<Scalars['String']>;
  GuiltyVehicleModelRgsCode?: Maybe<Scalars['String']>;
  GuiltyVehicleSteeringWheelRgs?: Maybe<Scalars['Boolean']>;
  GuiltyVehicleStyleRgsCode?: Maybe<Scalars['String']>;
  Guiltyvin?: Maybe<Scalars['String']>;
  IncidentLicensePlateUp?: Maybe<Scalars['String']>;
  IncidentRegistrationDateRgs?: Maybe<Scalars['DateTime']>;
  IncidentRegistrationYear?: Maybe<Scalars['Float']>;
  IncidentVINRequired?: Maybe<Scalars['Boolean']>;
  IncidentVehicleBodyNumber?: Maybe<Scalars['String']>;
  IncidentVehicleEnginePowerRgs?: Maybe<Scalars['Float']>;
  IncidentVehicleMakeRgsCode?: Maybe<Scalars['String']>;
  IncidentVehicleModelRgsCode?: Maybe<Scalars['String']>;
  IncidentVehicleSteeringWheelRgs?: Maybe<Scalars['Boolean']>;
  IncidentVehicleStyleRgsCode?: Maybe<Scalars['String']>;
  Incidentvin?: Maybe<Scalars['String']>;
  IsOnlyGlassDamagedRgs?: Maybe<Scalars['Boolean']>;
  IsResident?: Maybe<Scalars['Boolean']>;
  KorpusRgs?: Maybe<Scalars['String']>;
  KvartiraOfficeRgs?: Maybe<Scalars['String']>;
  Lastname?: Maybe<Scalars['String']>;
  LicenseNumber?: Maybe<Scalars['String']>;
  LicenseSeriesRgs?: Maybe<Scalars['String']>;
  LossBeforePremiumPaidRgs?: Maybe<Scalars['Boolean']>;
  LossDate?: Maybe<Scalars['DateTime']>;
  Middlename?: Maybe<Scalars['String']>;
  OutID?: Maybe<Scalars['String']>;
  OverTwoTimesLossRgs?: Maybe<Scalars['Boolean']>;
  OverlimitPropertyLossRgs?: Maybe<Scalars['Boolean']>;
  PersonTypeId?: Maybe<Scalars['String']>;
  PointCode?: Maybe<Scalars['Boolean']>;
  PolicyNumber?: Maybe<Scalars['String']>;
  PolicySeriesRgs?: Maybe<Scalars['String']>;
  PolicyTypeCode?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  ReportedDate?: Maybe<Scalars['DateTime']>;
  Risk?: Maybe<Scalars['String']>;
  RiskGroup?: Maybe<Scalars['String']>;
  SendDocsRequired?: Maybe<Scalars['Boolean']>;
  SettlementRgsCode?: Maybe<Scalars['String']>;
  StateCode?: Maybe<Scalars['String']>;
  StreetRgs?: Maybe<Scalars['String']>;
  StreetTypeRgsCode?: Maybe<Scalars['String']>;
  StroenieRgs?: Maybe<Scalars['String']>;
  TerritoryRgsCode?: Maybe<Scalars['String']>;
  VehicleOperable?: Maybe<Scalars['Boolean']>;
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedFloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type Property = {
  __typename?: 'Property';
  active: Scalars['Boolean'];
  bx_id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  kind: PropertyKind;
  multiple: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  type: PropertyType;
  updatedAt: Scalars['DateTime'];
  values: Array<PropertyValue>;
  valuesEnum: Array<PropertyEnum>;
  valuesRelation: Array<PropertyRelation>;
};


export type PropertyValuesArgs = {
  after?: Maybe<PropertyValueWhereUniqueInput>;
  before?: Maybe<PropertyValueWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PropertyValuesEnumArgs = {
  after?: Maybe<PropertyEnumWhereUniqueInput>;
  before?: Maybe<PropertyEnumWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PropertyValuesRelationArgs = {
  after?: Maybe<PropertyRelationWhereUniqueInput>;
  before?: Maybe<PropertyRelationWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PropertyEnum = {
  __typename?: 'PropertyEnum';
  bx_id?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  elements: Array<Element>;
  iblock?: Maybe<Iblock>;
  iblock_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};


export type PropertyEnumElementsArgs = {
  after?: Maybe<ElementWhereUniqueInput>;
  before?: Maybe<ElementWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PropertyEnumListRelationFilter = {
  every?: Maybe<PropertyEnumWhereInput>;
  none?: Maybe<PropertyEnumWhereInput>;
  some?: Maybe<PropertyEnumWhereInput>;
};

export type PropertyEnumOrderByInput = {
  bx_id?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  iblock_id?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  property_id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type PropertyEnumWhereInput = {
  AND?: Maybe<Array<PropertyEnumWhereInput>>;
  NOT?: Maybe<Array<PropertyEnumWhereInput>>;
  OR?: Maybe<Array<PropertyEnumWhereInput>>;
  bx_id?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  elements?: Maybe<ElementListRelationFilter>;
  iblock?: Maybe<IblockWhereInput>;
  iblock_id?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  property?: Maybe<PropertyWhereInput>;
  property_id?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<StringFilter>;
};

export type PropertyEnumWhereUniqueInput = {
  bx_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export enum PropertyKind {
  Element = 'ELEMENT',
  Section = 'SECTION'
}

export type PropertyOrderByInput = {
  active?: Maybe<SortOrder>;
  bx_id?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  kind?: Maybe<SortOrder>;
  multiple?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PropertyRelation = {
  __typename?: 'PropertyRelation';
  createdAt: Scalars['DateTime'];
  element?: Maybe<Element>;
  element_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['String']>;
  section?: Maybe<Section>;
  section_id?: Maybe<Scalars['String']>;
  targetElement?: Maybe<Element>;
  targetElement_id?: Maybe<Scalars['String']>;
  targetFile?: Maybe<File>;
  targetFile_id?: Maybe<Scalars['String']>;
  targetSection?: Maybe<Section>;
  targetSection_id?: Maybe<Scalars['String']>;
  targetUser?: Maybe<User>;
  targetUser_id?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PropertyRelationListRelationFilter = {
  every?: Maybe<PropertyRelationWhereInput>;
  none?: Maybe<PropertyRelationWhereInput>;
  some?: Maybe<PropertyRelationWhereInput>;
};

export type PropertyRelationOrderByInput = {
  createdAt?: Maybe<SortOrder>;
  element_id?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  property_id?: Maybe<SortOrder>;
  section_id?: Maybe<SortOrder>;
  targetElement_id?: Maybe<SortOrder>;
  targetFile_id?: Maybe<SortOrder>;
  targetSection_id?: Maybe<SortOrder>;
  targetUser_id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type PropertyRelationWhereInput = {
  AND?: Maybe<Array<PropertyRelationWhereInput>>;
  NOT?: Maybe<Array<PropertyRelationWhereInput>>;
  OR?: Maybe<Array<PropertyRelationWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  element?: Maybe<ElementWhereInput>;
  element_id?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  property?: Maybe<PropertyWhereInput>;
  property_id?: Maybe<StringNullableFilter>;
  section?: Maybe<SectionWhereInput>;
  section_id?: Maybe<StringNullableFilter>;
  targetElement?: Maybe<ElementWhereInput>;
  targetElement_id?: Maybe<StringNullableFilter>;
  targetFile?: Maybe<FileWhereInput>;
  targetFile_id?: Maybe<StringNullableFilter>;
  targetSection?: Maybe<SectionWhereInput>;
  targetSection_id?: Maybe<StringNullableFilter>;
  targetUser?: Maybe<UserWhereInput>;
  targetUser_id?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type PropertyRelationWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export enum PropertyType {
  Enum = 'ENUM',
  File = 'FILE',
  List = 'LIST',
  Relation = 'RELATION',
  String = 'STRING',
  User = 'USER'
}

export type PropertyValue = {
  __typename?: 'PropertyValue';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  element?: Maybe<Element>;
  element_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['String']>;
  section?: Maybe<Section>;
  section_id?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type PropertyValueListRelationFilter = {
  every?: Maybe<PropertyValueWhereInput>;
  none?: Maybe<PropertyValueWhereInput>;
  some?: Maybe<PropertyValueWhereInput>;
};

export type PropertyValueOrderByInput = {
  createdAt?: Maybe<SortOrder>;
  description?: Maybe<SortOrder>;
  element_id?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  property_id?: Maybe<SortOrder>;
  section_id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  value?: Maybe<SortOrder>;
};

export type PropertyValueWhereInput = {
  AND?: Maybe<Array<PropertyValueWhereInput>>;
  NOT?: Maybe<Array<PropertyValueWhereInput>>;
  OR?: Maybe<Array<PropertyValueWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  description?: Maybe<StringNullableFilter>;
  element?: Maybe<ElementWhereInput>;
  element_id?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  property?: Maybe<PropertyWhereInput>;
  property_id?: Maybe<StringNullableFilter>;
  section?: Maybe<SectionWhereInput>;
  section_id?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  value?: Maybe<StringFilter>;
};

export type PropertyValueWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type PropertyWhereInput = {
  AND?: Maybe<Array<PropertyWhereInput>>;
  NOT?: Maybe<Array<PropertyWhereInput>>;
  OR?: Maybe<Array<PropertyWhereInput>>;
  active?: Maybe<BoolFilter>;
  bx_id?: Maybe<IntNullableFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<StringFilter>;
  kind?: Maybe<PropertyKind>;
  multiple?: Maybe<BoolFilter>;
  name?: Maybe<StringNullableFilter>;
  type?: Maybe<PropertyType>;
  updatedAt?: Maybe<DateTimeFilter>;
  values?: Maybe<PropertyValueListRelationFilter>;
  valuesEnum?: Maybe<PropertyEnumListRelationFilter>;
  valuesRelation?: Maybe<PropertyRelationListRelationFilter>;
};

export type PropertyWhereUniqueInput = {
  bx_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  element?: Maybe<Element>;
  elements: Array<Element>;
  elementsCount?: Maybe<Scalars['Int']>;
  properties: Array<Property>;
  property?: Maybe<Property>;
  section?: Maybe<Section>;
  sections: Array<Section>;
  serviceClaimRgsGetUserClaimStatus?: Maybe<Scalars['Json']>;
  serviceExportGetRef?: Maybe<Array<Scalars['Json']>>;
  serviceExportGetRefCities?: Maybe<Array<Scalars['String']>>;
  serviceExportGetRefCountries?: Maybe<Array<Scalars['String']>>;
};


export type QueryElementArgs = {
  where: ElementWhereUniqueInput;
};


export type QueryElementsArgs = {
  after?: Maybe<ElementWhereUniqueInput>;
  before?: Maybe<ElementWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ElementOrderByInput>>;
  where?: Maybe<ElementWhereInput>;
};


export type QueryElementsCountArgs = {
  where?: Maybe<ElementWhereInput>;
};


export type QueryPropertiesArgs = {
  after?: Maybe<PropertyWhereUniqueInput>;
  before?: Maybe<PropertyWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PropertyOrderByInput>>;
  where?: Maybe<PropertyWhereInput>;
};


export type QueryPropertyArgs = {
  where: PropertyWhereUniqueInput;
};


export type QuerySectionArgs = {
  where: SectionWhereUniqueInput;
};


export type QuerySectionsArgs = {
  after?: Maybe<SectionWhereUniqueInput>;
  before?: Maybe<SectionWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SectionOrderByInput>>;
  where?: Maybe<SectionWhereInput>;
};


export type QueryServiceClaimRgsGetUserClaimStatusArgs = {
  claimNumber?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};


export type QueryServiceExportGetRefArgs = {
  regNum?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryServiceExportGetRefCitiesArgs = {
  regNum?: Maybe<Scalars['String']>;
};


export type QueryServiceExportGetRefCountriesArgs = {
  regNum?: Maybe<Scalars['String']>;
};

export type Section = {
  __typename?: 'Section';
  ChildsSections_: Array<Section>;
  PropertyRelationSection: Array<PropertyRelation>;
  PropertyRelationTargetSection: Array<PropertyRelation>;
  SectionPropertyValues: Array<PropertyValue>;
  active: Scalars['Boolean'];
  bx_id?: Maybe<Scalars['Int']>;
  childSections: Array<Section>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  elements: Array<Element>;
  iblock?: Maybe<Iblock>;
  iblock_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  parentSection?: Maybe<Section>;
  parentSection_id?: Maybe<Scalars['String']>;
  seo?: Maybe<Seo>;
  seo_id?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};


export type SectionChildsSections_Args = {
  after?: Maybe<SectionWhereUniqueInput>;
  before?: Maybe<SectionWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type SectionPropertyRelationSectionArgs = {
  after?: Maybe<PropertyRelationWhereUniqueInput>;
  before?: Maybe<PropertyRelationWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type SectionPropertyRelationTargetSectionArgs = {
  after?: Maybe<PropertyRelationWhereUniqueInput>;
  before?: Maybe<PropertyRelationWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type SectionSectionPropertyValuesArgs = {
  after?: Maybe<PropertyValueWhereUniqueInput>;
  before?: Maybe<PropertyValueWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type SectionChildSectionsArgs = {
  after?: Maybe<SectionWhereUniqueInput>;
  before?: Maybe<SectionWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SectionOrderByInput>>;
  where?: Maybe<SectionWhereInput>;
};


export type SectionElementsArgs = {
  after?: Maybe<ElementWhereUniqueInput>;
  before?: Maybe<ElementWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ElementOrderByInput>>;
  where?: Maybe<ElementWhereInput>;
};

export type SectionListRelationFilter = {
  every?: Maybe<SectionWhereInput>;
  none?: Maybe<SectionWhereInput>;
  some?: Maybe<SectionWhereInput>;
};

export type SectionOrderByInput = {
  active?: Maybe<SortOrder>;
  bx_id?: Maybe<SortOrder>;
  code?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  iblock_id?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  level?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  parentSection_id?: Maybe<SortOrder>;
  seo_id?: Maybe<SortOrder>;
  sort?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type SectionWhereInput = {
  AND?: Maybe<Array<SectionWhereInput>>;
  ChildsSections_?: Maybe<SectionListRelationFilter>;
  NOT?: Maybe<Array<SectionWhereInput>>;
  OR?: Maybe<Array<SectionWhereInput>>;
  PropertyRelationSection?: Maybe<PropertyRelationListRelationFilter>;
  PropertyRelationTargetSection?: Maybe<PropertyRelationListRelationFilter>;
  Section?: Maybe<SectionListRelationFilter>;
  SectionPropertyValues?: Maybe<PropertyValueListRelationFilter>;
  active?: Maybe<BoolFilter>;
  bx_id?: Maybe<IntNullableFilter>;
  childSections?: Maybe<SectionListRelationFilter>;
  code?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  elements?: Maybe<ElementListRelationFilter>;
  iblock?: Maybe<IblockWhereInput>;
  iblock_id?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  level?: Maybe<IntFilter>;
  name?: Maybe<StringNullableFilter>;
  parentSection?: Maybe<SectionWhereInput>;
  parentSection_id?: Maybe<StringNullableFilter>;
  seo?: Maybe<SeoWhereInput>;
  seo_id?: Maybe<StringNullableFilter>;
  sort?: Maybe<FloatNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type SectionWhereUniqueInput = {
  bx_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  seo_id?: Maybe<Scalars['String']>;
};

export type Seo = {
  __typename?: 'Seo';
  createdAt: Scalars['DateTime'];
  element?: Maybe<Element>;
  elementMetaDescription?: Maybe<Scalars['String']>;
  elementMetaKeywords?: Maybe<Scalars['String']>;
  elementMetaTitle?: Maybe<Scalars['String']>;
  elementPageTitle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  searchableContent?: Maybe<Scalars['String']>;
  section?: Maybe<Section>;
  sectionMetaDescription?: Maybe<Scalars['String']>;
  sectionMetaKeywords?: Maybe<Scalars['String']>;
  sectionMetaTitle?: Maybe<Scalars['String']>;
  sectionPageTitle?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SeoWhereInput = {
  AND?: Maybe<Array<SeoWhereInput>>;
  NOT?: Maybe<Array<SeoWhereInput>>;
  OR?: Maybe<Array<SeoWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  element?: Maybe<ElementWhereInput>;
  elementMetaDescription?: Maybe<StringNullableFilter>;
  elementMetaKeywords?: Maybe<StringNullableFilter>;
  elementMetaTitle?: Maybe<StringNullableFilter>;
  elementPageTitle?: Maybe<StringNullableFilter>;
  id?: Maybe<StringFilter>;
  searchableContent?: Maybe<StringNullableFilter>;
  section?: Maybe<SectionWhereInput>;
  sectionMetaDescription?: Maybe<StringNullableFilter>;
  sectionMetaKeywords?: Maybe<StringNullableFilter>;
  sectionMetaTitle?: Maybe<StringNullableFilter>;
  sectionPageTitle?: Maybe<StringNullableFilter>;
  tags?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};


export type User = {
  __typename?: 'User';
  area?: Maybe<Scalars['String']>;
  avatar?: Maybe<File>;
  avatar_id?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  bx_id?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  elements: Array<Element>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  groups: Array<Group>;
  id: Scalars['String'];
  login: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  patronymic?: Maybe<Scalars['String']>;
  propertyValuesRelation: Array<PropertyRelation>;
  provider_id?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  workPosition?: Maybe<Scalars['String']>;
  xml_id?: Maybe<Scalars['String']>;
};


export type UserElementsArgs = {
  after?: Maybe<ElementWhereUniqueInput>;
  before?: Maybe<ElementWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserGroupsArgs = {
  after?: Maybe<GroupWhereUniqueInput>;
  before?: Maybe<GroupWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<GroupOrderByInput>>;
  where?: Maybe<GroupWhereInput>;
};


export type UserPropertyValuesRelationArgs = {
  after?: Maybe<PropertyRelationWhereUniqueInput>;
  before?: Maybe<PropertyRelationWhereUniqueInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type UserListRelationFilter = {
  every?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: Maybe<Array<UserWhereInput>>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  area?: Maybe<StringNullableFilter>;
  avatar?: Maybe<FileWhereInput>;
  avatar_id?: Maybe<StringNullableFilter>;
  birthday?: Maybe<DateTimeNullableFilter>;
  bx_id?: Maybe<IntNullableFilter>;
  city?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  elements?: Maybe<ElementListRelationFilter>;
  email?: Maybe<StringNullableFilter>;
  fullName?: Maybe<StringNullableFilter>;
  gender?: Maybe<StringNullableFilter>;
  groups?: Maybe<GroupListRelationFilter>;
  id?: Maybe<StringFilter>;
  login?: Maybe<StringFilter>;
  modifiedElements?: Maybe<ElementListRelationFilter>;
  name?: Maybe<StringNullableFilter>;
  notes?: Maybe<StringNullableFilter>;
  password?: Maybe<StringFilter>;
  patronymic?: Maybe<StringNullableFilter>;
  phone?: Maybe<StringNullableFilter>;
  propertyValuesRelation?: Maybe<PropertyRelationListRelationFilter>;
  provider_id?: Maybe<StringNullableFilter>;
  street?: Maybe<StringNullableFilter>;
  surname?: Maybe<StringNullableFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
  workPosition?: Maybe<StringNullableFilter>;
  xml_id?: Maybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  bx_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  xml_id?: Maybe<Scalars['String']>;
};

export type CreateElementMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iblockCode?: Maybe<Scalars['String']>;
  emailPropId?: Maybe<Scalars['String']>;
  bankNameValue?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;


export type CreateElementMutation = { __typename?: 'Mutation', createElement?: Maybe<boolean> };

export type InitQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type InitQueryQuery = { __typename?: 'Query', sections: Array<{ __typename?: 'Section', id: string, name?: Maybe<string>, code: string, level: number, parentSection?: Maybe<{ __typename?: 'Section', id: string, code: string, level: number }>, childSections: Array<{ __typename?: 'Section', id: string, code: string, level: number }>, elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, updatedAt: any, code?: Maybe<string>, sort?: Maybe<number>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }>, seo?: Maybe<{ __typename?: 'Seo', sectionMetaTitle?: Maybe<string>, sectionMetaDescription?: Maybe<string> }> }>, settings: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, code?: Maybe<string>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }>, navigation: Array<{ __typename?: 'Section', id: string, name?: Maybe<string>, code: string, level: number, sort?: Maybe<number>, parentSection?: Maybe<{ __typename?: 'Section', id: string }>, elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, sort?: Maybe<number>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }> }>, redirects: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, code?: Maybe<string>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> };

export type Init_ProperyValuesFragment = { __typename?: 'Element', propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type Init_PropertyValuesEnumFragment = { __typename?: 'Element', propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type Init_PropertyValuesRelationFragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> };

export type Init_RelationLvl_1Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> };

export type Init_RelationLvl_2Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> };

export type Settings_PropertyValuesRelationFragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> };

export type Settings_PropertyValuesRelation_2Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> };

export type Settings_PropertyValuesRelation_3Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Settings_PropertyValuesRelation_4Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Settings_PropertyValuesRelation_5Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Init_RelationLvl_3Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Init_RelationLvl_4Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Init_RelationLvl_5Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type LeadsQueryQueryVariables = Exact<{
  slugLead?: Maybe<Scalars['String']>;
}>;


export type LeadsQueryQuery = { __typename?: 'Query', elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, code?: Maybe<string>, seo?: Maybe<{ __typename?: 'Seo', elementPageTitle?: Maybe<string>, elementMetaDescription?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }> };

export type Leads_ProperyValuesFragment = { __typename?: 'Element', propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type Leads_PropertyValuesRelationFragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> };

export type Leads_PropertyValuesEnumFragment = { __typename?: 'Element', propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type Leads_RelationLvl_2Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> };

export type Leads_RelationLvl_3Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Leads_ReletionLvl_4Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Leads_RelationLvl_5Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type NewsQueryQueryVariables = Exact<{
  after?: Maybe<ElementWhereUniqueInput>;
  orderBy?: Maybe<Array<ElementOrderByInput> | ElementOrderByInput>;
  searchString?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  codeNews?: Maybe<Scalars['String']>;
  tagsSearch?: Maybe<PropertyRelationListRelationFilter>;
  notId?: Maybe<Scalars['String']>;
}>;


export type NewsQueryQuery = { __typename?: 'Query', elementsCount?: Maybe<number>, elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, activeFrom?: Maybe<any>, code?: Maybe<string>, seo?: Maybe<{ __typename?: 'Seo', elementPageTitle?: Maybe<string>, elementMetaDescription?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }> };

export type News_ProperyValuesFragment = { __typename?: 'Element', propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type News_PropertyValuesRelationFragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> };

export type News_PropertyValuesEnumFragment = { __typename?: 'Element', propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type News_RelationLvl_2Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> };

export type News_RelationLvl_3Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type News_ReletionLvl_4Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type News_RelationLvl_5Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type PageQueryQueryVariables = Exact<{
  where?: Maybe<ElementWhereInput>;
  first?: Maybe<Scalars['Int']>;
}>;


export type PageQueryQuery = { __typename?: 'Query', elements: Array<{ __typename?: 'Element', id: string, bx_id?: Maybe<number>, name?: Maybe<string>, code?: Maybe<string>, activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> };

export type PropertyValuesFragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }> };

export type TargetFileFragment = { __typename?: 'PropertyRelation', targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> };

export type TargetElementFragment = { __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }> };

export type PropertyFragment = { __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }> };

export type PropertyValuesRelationFragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> };

export type PropertyValuesEnumFragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type RelationLvl_2Fragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> };

export type RelationLvl_3Fragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> };

export type ReletionLvl_4Fragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> };

export type RelationLvl_5Fragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> };

export type RelationLvl_6Fragment = { __typename?: 'Element', activeFrom?: Maybe<any>, activeTo?: Maybe<any>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, bx_id?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, updatedAt: any, activeTo?: Maybe<any>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', description?: Maybe<string>, id: string, value: string, property?: Maybe<{ __typename?: 'Property', bx_id?: Maybe<number>, code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }>, property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }> }> };

export type ProductsQueryQueryVariables = Exact<{
  slugProduct?: Maybe<Scalars['String']>;
  blockName?: Maybe<Scalars['String']>;
}>;


export type ProductsQueryQuery = { __typename?: 'Query', elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, code?: Maybe<string>, seo?: Maybe<{ __typename?: 'Seo', elementPageTitle?: Maybe<string>, elementMetaDescription?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }> };

export type Products_ProperyValuesFragment = { __typename?: 'Element', propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type Products_PropertyValuesRelationFragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> };

export type Products_PropertyValuesEnumFragment = { __typename?: 'Element', propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> };

export type Products_RelationLvl_2Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> };

export type Products_RelationLvl_3Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Products_ReletionLvl_4Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type Products_RelationLvl_5Fragment = { __typename?: 'Element', propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', sort?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, id: string, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> };

export type SearchQueryQueryVariables = Exact<{
  searchString?: Maybe<Scalars['String']>;
  searchCategory?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<ElementWhereUniqueInput>;
  orderBy?: Maybe<Array<ElementOrderByInput> | ElementOrderByInput>;
}>;


export type SearchQueryQuery = { __typename?: 'Query', elementsCount?: Maybe<number>, elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, activeFrom?: Maybe<any>, active: boolean, code?: Maybe<string>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, seo?: Maybe<{ __typename?: 'Seo', elementPageTitle?: Maybe<string>, elementMetaDescription?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string, type: PropertyType, kind: PropertyKind }>, targetFile?: Maybe<{ __typename?: 'File', url: string, size: number, contentType: string }>, targetElement?: Maybe<{ __typename?: 'Element', iblock?: Maybe<{ __typename?: 'Iblock', name: string, id: string, code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string }> }> }> }> };

export type SitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, code?: Maybe<string>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string }>, targetSection?: Maybe<{ __typename?: 'Section', code: string, name?: Maybe<string> }> }> }>, seoAuto: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string }>, targetElement?: Maybe<{ __typename?: 'Element', code?: Maybe<string>, name?: Maybe<string>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string }>, targetElement?: Maybe<{ __typename?: 'Element', code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }> }> }> }> }>, seoRegion: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }>, seoCountry: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }>, seoRisks: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }>, seoSports: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }>, seoDevelopers: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }>, sections: Array<{ __typename?: 'Section', id: string, name?: Maybe<string>, code: string, level: number, parentSection?: Maybe<{ __typename?: 'Section', id: string, level: number, code: string }>, childSections: Array<{ __typename?: 'Section', id: string, code: string, level: number }>, elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, code?: Maybe<string>, updatedAt: any, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }>, leads: Array<{ __typename?: 'Element', id: string, code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }> };

export type SitemapNewsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapNewsQueryQuery = { __typename?: 'Query', news: Array<{ __typename?: 'Element', code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }> };

export type SitemapCareerQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapCareerQueryQuery = { __typename?: 'Query', vacancies: Array<{ __typename?: 'Element', code?: Maybe<string>, name?: Maybe<string>, updatedAt: any }> };

export type TestQuestionQueryVariables = Exact<{
  where?: Maybe<ElementWhereInput>;
}>;


export type TestQuestionQuery = { __typename?: 'Query', elements: Array<{ __typename?: 'Element', id: string, name?: Maybe<string>, activeFrom?: Maybe<any>, sort?: Maybe<number>, code?: Maybe<string>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', id: string, property?: Maybe<{ __typename?: 'Property', code: string }>, targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, code?: Maybe<string>, id: string, name?: Maybe<string>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string }>, targetElement?: Maybe<{ __typename?: 'Element', activeFrom?: Maybe<any>, sort?: Maybe<number>, code?: Maybe<string>, id: string, name?: Maybe<string>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string }>, targetElement?: Maybe<{ __typename?: 'Element', id: string, name?: Maybe<string>, activeFrom?: Maybe<any>, sort?: Maybe<number>, code?: Maybe<string>, iblock?: Maybe<{ __typename?: 'Iblock', code?: Maybe<string> }>, propertyValuesEnum: Array<{ __typename?: 'PropertyEnum', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }>, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, property?: Maybe<{ __typename?: 'Property', code: string }> }> }> }> }> }> }> }> }> };

export type GetVacanciesQueryVariables = Exact<{
  filter?: Maybe<ElementWhereInput>;
  first?: Maybe<Scalars['Int']>;
}>;


export type GetVacanciesQuery = { __typename?: 'Query', elementsCount?: Maybe<number>, elements: Array<{ __typename?: 'Element', name?: Maybe<string>, code?: Maybe<string>, createdAt: any, propertyValues: Array<{ __typename?: 'PropertyValue', value: string, id: string, property?: Maybe<{ __typename?: 'Property', name?: Maybe<string>, code: string }> }>, propertyValuesRelation: Array<{ __typename?: 'PropertyRelation', property?: Maybe<{ __typename?: 'Property', code: string }>, targetElement?: Maybe<{ __typename?: 'Element', name?: Maybe<string> }> }> }> };

export const Init_ProperyValuesFragmentDoc = gql`
    fragment init_properyValues on Element {
  propertyValues {
    property {
      code
    }
    value
  }
}
    `;
export const Init_PropertyValuesEnumFragmentDoc = gql`
    fragment init_propertyValuesEnum on Element {
  propertyValuesEnum {
    property {
      code
    }
    value
  }
}
    `;
export const Init_RelationLvl_5FragmentDoc = gql`
    fragment init_relationLvl_5 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...init_propertyValuesEnum
    }
  }
}
    ${Init_PropertyValuesEnumFragmentDoc}`;
export const Init_RelationLvl_4FragmentDoc = gql`
    fragment init_relationLvl_4 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...init_relationLvl_5
      ...init_propertyValuesEnum
    }
  }
}
    ${Init_RelationLvl_5FragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}`;
export const Init_RelationLvl_3FragmentDoc = gql`
    fragment init_relationLvl_3 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...init_relationLvl_4
      ...init_propertyValuesEnum
    }
  }
}
    ${Init_RelationLvl_4FragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}`;
export const Init_RelationLvl_2FragmentDoc = gql`
    fragment init_relationLvl_2 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...init_properyValues
      ...init_propertyValuesEnum
      ...init_relationLvl_3
    }
  }
}
    ${Init_ProperyValuesFragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}
${Init_RelationLvl_3FragmentDoc}`;
export const Init_PropertyValuesRelationFragmentDoc = gql`
    fragment init_propertyValuesRelation on Element {
  propertyValuesRelation(
    where: {property: {code: {in: ["card", "locationRegion", "locationCity"]}}}
  ) {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...init_properyValues
      ...init_propertyValuesEnum
      ...init_relationLvl_2
    }
  }
}
    ${Init_ProperyValuesFragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}
${Init_RelationLvl_2FragmentDoc}`;
export const Init_RelationLvl_1FragmentDoc = gql`
    fragment init_relationLvl_1 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...init_properyValues
      ...init_propertyValuesEnum
      ...init_relationLvl_2
    }
  }
}
    ${Init_ProperyValuesFragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}
${Init_RelationLvl_2FragmentDoc}`;
export const Settings_PropertyValuesRelation_5FragmentDoc = gql`
    fragment settings_propertyValuesRelation_5 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
    }
    targetSection {
      code
      name
    }
    targetFile {
      url
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...init_propertyValuesEnum
    }
  }
}
    ${Init_PropertyValuesEnumFragmentDoc}`;
export const Settings_PropertyValuesRelation_4FragmentDoc = gql`
    fragment settings_propertyValuesRelation_4 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...settings_propertyValuesRelation_5
      ...init_propertyValuesEnum
    }
  }
}
    ${Settings_PropertyValuesRelation_5FragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}`;
export const Settings_PropertyValuesRelation_3FragmentDoc = gql`
    fragment settings_propertyValuesRelation_3 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...settings_propertyValuesRelation_4
      ...init_propertyValuesEnum
    }
  }
}
    ${Settings_PropertyValuesRelation_4FragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}`;
export const Settings_PropertyValuesRelation_2FragmentDoc = gql`
    fragment settings_propertyValuesRelation_2 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...init_properyValues
      ...init_propertyValuesEnum
      ...settings_propertyValuesRelation_3
    }
  }
}
    ${Init_ProperyValuesFragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}
${Settings_PropertyValuesRelation_3FragmentDoc}`;
export const Settings_PropertyValuesRelationFragmentDoc = gql`
    fragment settings_propertyValuesRelation on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
    }
    targetSection {
      code
      name
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...init_properyValues
      ...init_propertyValuesEnum
      ...settings_propertyValuesRelation_2
    }
  }
}
    ${Init_ProperyValuesFragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}
${Settings_PropertyValuesRelation_2FragmentDoc}`;
export const Leads_ProperyValuesFragmentDoc = gql`
    fragment leads_properyValues on Element {
  propertyValues {
    property {
      code
    }
    value
  }
}
    `;
export const Leads_PropertyValuesEnumFragmentDoc = gql`
    fragment leads_propertyValuesEnum on Element {
  propertyValuesEnum {
    property {
      code
    }
    value
  }
}
    `;
export const Leads_RelationLvl_5FragmentDoc = gql`
    fragment leads_relationLvl_5 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...leads_propertyValuesEnum
    }
  }
}
    ${Leads_PropertyValuesEnumFragmentDoc}`;
export const Leads_ReletionLvl_4FragmentDoc = gql`
    fragment leads_reletionLvl_4 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...leads_relationLvl_5
      ...leads_propertyValuesEnum
    }
  }
}
    ${Leads_RelationLvl_5FragmentDoc}
${Leads_PropertyValuesEnumFragmentDoc}`;
export const Leads_RelationLvl_3FragmentDoc = gql`
    fragment leads_relationLvl_3 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...leads_reletionLvl_4
      ...leads_propertyValuesEnum
    }
  }
}
    ${Leads_ReletionLvl_4FragmentDoc}
${Leads_PropertyValuesEnumFragmentDoc}`;
export const Leads_RelationLvl_2FragmentDoc = gql`
    fragment leads_relationLvl_2 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...leads_properyValues
      ...leads_propertyValuesEnum
      ...leads_relationLvl_3
    }
  }
}
    ${Leads_ProperyValuesFragmentDoc}
${Leads_PropertyValuesEnumFragmentDoc}
${Leads_RelationLvl_3FragmentDoc}`;
export const Leads_PropertyValuesRelationFragmentDoc = gql`
    fragment leads_propertyValuesRelation on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...leads_properyValues
      ...leads_propertyValuesEnum
      ...leads_relationLvl_2
    }
  }
}
    ${Leads_ProperyValuesFragmentDoc}
${Leads_PropertyValuesEnumFragmentDoc}
${Leads_RelationLvl_2FragmentDoc}`;
export const News_ProperyValuesFragmentDoc = gql`
    fragment news_properyValues on Element {
  propertyValues {
    property {
      code
    }
    value
  }
}
    `;
export const News_PropertyValuesEnumFragmentDoc = gql`
    fragment news_propertyValuesEnum on Element {
  propertyValuesEnum {
    property {
      code
    }
    value
  }
}
    `;
export const News_RelationLvl_5FragmentDoc = gql`
    fragment news_relationLvl_5 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...news_propertyValuesEnum
    }
  }
}
    ${News_PropertyValuesEnumFragmentDoc}`;
export const News_ReletionLvl_4FragmentDoc = gql`
    fragment news_reletionLvl_4 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...news_relationLvl_5
      ...news_propertyValuesEnum
    }
  }
}
    ${News_RelationLvl_5FragmentDoc}
${News_PropertyValuesEnumFragmentDoc}`;
export const News_RelationLvl_3FragmentDoc = gql`
    fragment news_relationLvl_3 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...news_reletionLvl_4
      ...news_propertyValuesEnum
    }
  }
}
    ${News_ReletionLvl_4FragmentDoc}
${News_PropertyValuesEnumFragmentDoc}`;
export const News_RelationLvl_2FragmentDoc = gql`
    fragment news_relationLvl_2 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...news_properyValues
      ...news_propertyValuesEnum
      ...news_relationLvl_3
    }
  }
}
    ${News_ProperyValuesFragmentDoc}
${News_PropertyValuesEnumFragmentDoc}
${News_RelationLvl_3FragmentDoc}`;
export const News_PropertyValuesRelationFragmentDoc = gql`
    fragment news_propertyValuesRelation on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...news_properyValues
      ...news_propertyValuesEnum
      ...news_relationLvl_2
    }
  }
}
    ${News_ProperyValuesFragmentDoc}
${News_PropertyValuesEnumFragmentDoc}
${News_RelationLvl_2FragmentDoc}`;
export const PropertyFragmentDoc = gql`
    fragment property on PropertyRelation {
  property {
    code
    type
    kind
  }
}
    `;
export const TargetFileFragmentDoc = gql`
    fragment targetFile on PropertyRelation {
  targetFile {
    url
    size
    contentType
  }
}
    `;
export const TargetElementFragmentDoc = gql`
    fragment targetElement on Element {
  iblock {
    code
  }
  activeFrom
  sort
  bx_id
  code
  name
  id
  bx_id
  updatedAt
}
    `;
export const PropertyValuesFragmentDoc = gql`
    fragment propertyValues on Element {
  propertyValues {
    property {
      bx_id
      code
    }
    description
    id
    value
  }
  activeFrom
  activeTo
}
    `;
export const PropertyValuesEnumFragmentDoc = gql`
    fragment propertyValuesEnum on Element {
  propertyValuesEnum {
    property {
      code
    }
    value
  }
  activeFrom
  activeTo
}
    `;
export const RelationLvl_6FragmentDoc = gql`
    fragment relationLvl_6 on Element {
  propertyValuesRelation {
    ...property
    ...targetFile
    targetElement {
      ...targetElement
      ...propertyValues
      ...propertyValuesEnum
    }
  }
  activeFrom
  activeTo
}
    ${PropertyFragmentDoc}
${TargetFileFragmentDoc}
${TargetElementFragmentDoc}
${PropertyValuesFragmentDoc}
${PropertyValuesEnumFragmentDoc}`;
export const RelationLvl_5FragmentDoc = gql`
    fragment relationLvl_5 on Element {
  propertyValuesRelation {
    ...property
    ...targetFile
    targetElement {
      ...targetElement
      ...propertyValues
      ...relationLvl_6
      ...propertyValuesEnum
    }
  }
  activeFrom
  activeTo
}
    ${PropertyFragmentDoc}
${TargetFileFragmentDoc}
${TargetElementFragmentDoc}
${PropertyValuesFragmentDoc}
${RelationLvl_6FragmentDoc}
${PropertyValuesEnumFragmentDoc}`;
export const ReletionLvl_4FragmentDoc = gql`
    fragment reletionLvl_4 on Element {
  propertyValuesRelation {
    ...property
    ...targetFile
    targetElement {
      ...targetElement
      ...propertyValues
      ...relationLvl_5
      ...propertyValuesEnum
    }
  }
  activeFrom
  activeTo
}
    ${PropertyFragmentDoc}
${TargetFileFragmentDoc}
${TargetElementFragmentDoc}
${PropertyValuesFragmentDoc}
${RelationLvl_5FragmentDoc}
${PropertyValuesEnumFragmentDoc}`;
export const RelationLvl_3FragmentDoc = gql`
    fragment relationLvl_3 on Element {
  propertyValuesRelation {
    ...property
    ...targetFile
    targetElement {
      ...targetElement
      ...propertyValues
      ...reletionLvl_4
      ...propertyValuesEnum
    }
  }
  activeFrom
  activeTo
}
    ${PropertyFragmentDoc}
${TargetFileFragmentDoc}
${TargetElementFragmentDoc}
${PropertyValuesFragmentDoc}
${ReletionLvl_4FragmentDoc}
${PropertyValuesEnumFragmentDoc}`;
export const RelationLvl_2FragmentDoc = gql`
    fragment relationLvl_2 on Element {
  propertyValuesRelation {
    ...property
    ...targetFile
    targetElement {
      ...targetElement
      ...propertyValues
      ...propertyValuesEnum
      ...relationLvl_3
    }
  }
  activeFrom
  activeTo
}
    ${PropertyFragmentDoc}
${TargetFileFragmentDoc}
${TargetElementFragmentDoc}
${PropertyValuesFragmentDoc}
${PropertyValuesEnumFragmentDoc}
${RelationLvl_3FragmentDoc}`;
export const PropertyValuesRelationFragmentDoc = gql`
    fragment propertyValuesRelation on Element {
  propertyValuesRelation {
    ...property
    ...targetFile
    targetElement {
      ...targetElement
      ...propertyValues
      ...propertyValuesEnum
      ...relationLvl_2
    }
  }
  activeFrom
  activeTo
}
    ${PropertyFragmentDoc}
${TargetFileFragmentDoc}
${TargetElementFragmentDoc}
${PropertyValuesFragmentDoc}
${PropertyValuesEnumFragmentDoc}
${RelationLvl_2FragmentDoc}`;
export const Products_ProperyValuesFragmentDoc = gql`
    fragment products_properyValues on Element {
  propertyValues {
    property {
      code
    }
    value
  }
}
    `;
export const Products_PropertyValuesEnumFragmentDoc = gql`
    fragment products_propertyValuesEnum on Element {
  propertyValuesEnum {
    property {
      code
    }
    value
  }
}
    `;
export const Products_RelationLvl_5FragmentDoc = gql`
    fragment products_relationLvl_5 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...products_propertyValuesEnum
    }
  }
}
    ${Products_PropertyValuesEnumFragmentDoc}`;
export const Products_ReletionLvl_4FragmentDoc = gql`
    fragment products_reletionLvl_4 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...products_relationLvl_5
      ...products_propertyValuesEnum
    }
  }
}
    ${Products_RelationLvl_5FragmentDoc}
${Products_PropertyValuesEnumFragmentDoc}`;
export const Products_RelationLvl_3FragmentDoc = gql`
    fragment products_relationLvl_3 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      propertyValues {
        property {
          code
        }
        value
      }
      ...products_reletionLvl_4
      ...products_propertyValuesEnum
    }
  }
}
    ${Products_ReletionLvl_4FragmentDoc}
${Products_PropertyValuesEnumFragmentDoc}`;
export const Products_RelationLvl_2FragmentDoc = gql`
    fragment products_relationLvl_2 on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...products_properyValues
      ...products_propertyValuesEnum
      ...products_relationLvl_3
    }
  }
}
    ${Products_ProperyValuesFragmentDoc}
${Products_PropertyValuesEnumFragmentDoc}
${Products_RelationLvl_3FragmentDoc}`;
export const Products_PropertyValuesRelationFragmentDoc = gql`
    fragment products_propertyValuesRelation on Element {
  propertyValuesRelation {
    property {
      code
      type
      kind
    }
    targetFile {
      url
      size
      contentType
    }
    targetElement {
      iblock {
        code
      }
      sort
      code
      name
      id
      ...products_properyValues
      ...products_propertyValuesEnum
      ...products_relationLvl_2
    }
  }
}
    ${Products_ProperyValuesFragmentDoc}
${Products_PropertyValuesEnumFragmentDoc}
${Products_RelationLvl_2FragmentDoc}`;
export const CreateElementDocument = gql`
    mutation createElement($name: String, $region: String, $secret: String, $description: String, $iblockCode: String, $emailPropId: String, $bankNameValue: String, $files: [Upload!]) {
  createElement(
    name: $name
    description: $description
    iblockCode: $iblockCode
    emailPropId: $emailPropId
    bankNameValue: $bankNameValue
    files: $files
    region: $region
    secret: $secret
  )
}
    `;

/**
 * __useCreateElementMutation__
 *
 * To run a mutation, you first call `useCreateElementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateElementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateElementMutation({
 *   variables: {
 *     name: // value for 'name'
 *     region: // value for 'region'
 *     secret: // value for 'secret'
 *     description: // value for 'description'
 *     iblockCode: // value for 'iblockCode'
 *     emailPropId: // value for 'emailPropId'
 *     bankNameValue: // value for 'bankNameValue'
 *     files: // value for 'files'
 *   },
 * });
 */
export function useCreateElementMutation(options: VueApolloComposable.UseMutationOptions<CreateElementMutation, CreateElementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateElementMutation, CreateElementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateElementMutation, CreateElementMutationVariables>(CreateElementDocument, options);
}
export type CreateElementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateElementMutation, CreateElementMutationVariables>;
export const InitQueryDocument = gql`
    query initQuery {
  sections(where: {iblock: {code: {equals: "pageConstructor"}}}) {
    id
    name
    code
    level
    parentSection {
      id
      code
      level
    }
    childSections {
      id
      code
      level
    }
    elements(where: {iblock: {code: {equals: "pageConstructor"}}}) {
      id
      name
      updatedAt
      code
      sort
      ...init_properyValues
      ...init_propertyValuesEnum
      ...init_propertyValuesRelation
    }
    seo {
      sectionMetaTitle
      sectionMetaDescription
    }
  }
  settings: elements(where: {iblock: {code: {equals: "siteSettings"}}}) {
    id
    name
    code
    ...init_properyValues
    ...init_propertyValuesEnum
    ...settings_propertyValuesRelation
  }
  navigation: sections(
    where: {iblock: {code: {equals: "navLinks"}}}
    orderBy: {sort: asc}
  ) {
    id
    name
    code
    level
    sort
    parentSection {
      id
    }
    elements(first: 1) {
      id
      name
      sort
      ...init_properyValues
      ...init_propertyValuesEnum
      ...init_relationLvl_1
    }
  }
  redirects: elements(where: {iblock: {code: {equals: "redirects"}}}) {
    id
    name
    code
    ...init_properyValues
  }
}
    ${Init_ProperyValuesFragmentDoc}
${Init_PropertyValuesEnumFragmentDoc}
${Init_PropertyValuesRelationFragmentDoc}
${Settings_PropertyValuesRelationFragmentDoc}
${Init_RelationLvl_1FragmentDoc}`;

/**
 * __useInitQueryQuery__
 *
 * To run a query within a Vue component, call `useInitQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInitQueryQuery();
 */
export function useInitQueryQuery(options: VueApolloComposable.UseQueryOptions<InitQueryQuery, InitQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InitQueryQuery, InitQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InitQueryQuery, InitQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InitQueryQuery, InitQueryQueryVariables>(InitQueryDocument, {}, options);
}
export type InitQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InitQueryQuery, InitQueryQueryVariables>;
export const LeadsQueryDocument = gql`
    query leadsQuery($slugLead: String) {
  elements(
    where: {iblock: {code: {equals: "blockLead"}}, code: {equals: $slugLead}}
  ) {
    id
    name
    code
    seo {
      elementPageTitle
      elementMetaDescription
    }
    ...leads_properyValues
    ...leads_propertyValuesEnum
    ...leads_propertyValuesRelation
  }
}
    ${Leads_ProperyValuesFragmentDoc}
${Leads_PropertyValuesEnumFragmentDoc}
${Leads_PropertyValuesRelationFragmentDoc}`;

/**
 * __useLeadsQueryQuery__
 *
 * To run a query within a Vue component, call `useLeadsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLeadsQueryQuery({
 *   slugLead: // value for 'slugLead'
 * });
 */
export function useLeadsQueryQuery(variables: LeadsQueryQueryVariables | VueCompositionApi.Ref<LeadsQueryQueryVariables> | ReactiveFunction<LeadsQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LeadsQueryQuery, LeadsQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LeadsQueryQuery, LeadsQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LeadsQueryQuery, LeadsQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LeadsQueryQuery, LeadsQueryQueryVariables>(LeadsQueryDocument, variables, options);
}
export type LeadsQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LeadsQueryQuery, LeadsQueryQueryVariables>;
export const NewsQueryDocument = gql`
    query newsQuery($after: ElementWhereUniqueInput, $orderBy: [ElementOrderByInput!], $searchString: String, $first: Int, $codeNews: String, $tagsSearch: PropertyRelationListRelationFilter, $notId: String) {
  elements(
    where: {iblock: {code: {equals: "rgs_news"}}, id: {not: {equals: $notId}}, propertyValues: {some: {value: {contains: $searchString}}}, propertyValuesRelation: $tagsSearch, code: {equals: $codeNews}}
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    id
    name
    activeFrom
    code
    seo {
      elementPageTitle
      elementMetaDescription
    }
    ...news_properyValues
    ...news_propertyValuesEnum
    ...news_propertyValuesRelation
  }
  elementsCount(where: {iblock: {code: {equals: "rgs_news"}}})
}
    ${News_ProperyValuesFragmentDoc}
${News_PropertyValuesEnumFragmentDoc}
${News_PropertyValuesRelationFragmentDoc}`;

/**
 * __useNewsQueryQuery__
 *
 * To run a query within a Vue component, call `useNewsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNewsQueryQuery({
 *   after: // value for 'after'
 *   orderBy: // value for 'orderBy'
 *   searchString: // value for 'searchString'
 *   first: // value for 'first'
 *   codeNews: // value for 'codeNews'
 *   tagsSearch: // value for 'tagsSearch'
 *   notId: // value for 'notId'
 * });
 */
export function useNewsQueryQuery(variables: NewsQueryQueryVariables | VueCompositionApi.Ref<NewsQueryQueryVariables> | ReactiveFunction<NewsQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<NewsQueryQuery, NewsQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NewsQueryQuery, NewsQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NewsQueryQuery, NewsQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NewsQueryQuery, NewsQueryQueryVariables>(NewsQueryDocument, variables, options);
}
export type NewsQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NewsQueryQuery, NewsQueryQueryVariables>;
export const PageQueryDocument = gql`
    query pageQuery($where: ElementWhereInput, $first: Int) {
  elements(first: $first, where: $where) {
    id
    bx_id
    name
    code
    activeFrom
    activeTo
    ...propertyValues
    ...propertyValuesRelation
    ...propertyValuesEnum
  }
}
    ${PropertyValuesFragmentDoc}
${PropertyValuesRelationFragmentDoc}
${PropertyValuesEnumFragmentDoc}`;

/**
 * __usePageQueryQuery__
 *
 * To run a query within a Vue component, call `usePageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePageQueryQuery({
 *   where: // value for 'where'
 *   first: // value for 'first'
 * });
 */
export function usePageQueryQuery(variables: PageQueryQueryVariables | VueCompositionApi.Ref<PageQueryQueryVariables> | ReactiveFunction<PageQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PageQueryQuery, PageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PageQueryQuery, PageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PageQueryQuery, PageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PageQueryQuery, PageQueryQueryVariables>(PageQueryDocument, variables, options);
}
export type PageQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PageQueryQuery, PageQueryQueryVariables>;
export const ProductsQueryDocument = gql`
    query productsQuery($slugProduct: String, $blockName: String) {
  elements(
    where: {iblock: {code: {equals: $blockName}}, code: {equals: $slugProduct}}
  ) {
    id
    name
    code
    seo {
      elementPageTitle
      elementMetaDescription
    }
    ...products_properyValues
    ...products_propertyValuesEnum
    ...products_propertyValuesRelation
  }
}
    ${Products_ProperyValuesFragmentDoc}
${Products_PropertyValuesEnumFragmentDoc}
${Products_PropertyValuesRelationFragmentDoc}`;

/**
 * __useProductsQueryQuery__
 *
 * To run a query within a Vue component, call `useProductsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductsQueryQuery({
 *   slugProduct: // value for 'slugProduct'
 *   blockName: // value for 'blockName'
 * });
 */
export function useProductsQueryQuery(variables: ProductsQueryQueryVariables | VueCompositionApi.Ref<ProductsQueryQueryVariables> | ReactiveFunction<ProductsQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ProductsQueryQuery, ProductsQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductsQueryQuery, ProductsQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductsQueryQuery, ProductsQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductsQueryQuery, ProductsQueryQueryVariables>(ProductsQueryDocument, variables, options);
}
export type ProductsQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductsQueryQuery, ProductsQueryQueryVariables>;
export const SearchQueryDocument = gql`
    query searchQuery($searchString: String, $searchCategory: String, $first: Int, $after: ElementWhereUniqueInput, $orderBy: [ElementOrderByInput!]) {
  elements(
    where: {iblock: {code: {equals: $searchCategory}}, propertyValues: {none: {value: {contains: "noindex, nofollow"}}}, AND: [{propertyValuesEnum: {none: {property: {OR: [{code: {equals: "hiddenPage"}}, {code: {equals: "uniquePages"}}]}}}}, {OR: [{AND: [{name: {contains: $searchString}}, {iblock: {code: {equals: $searchCategory}}}]}, {AND: [{propertyValues: {some: {value: {contains: $searchString}}}}, {iblock: {OR: [{code: {equals: "document"}}, {code: {equals: "rgs_news"}}]}}]}, {propertyValuesRelation: {some: {targetElement: {AND: [{iblock: {code: {equals: "sectionProductHero"}}}, {propertyValues: {some: {value: {contains: $searchString}}}}]}}}}]}]}
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    id
    name
    activeFrom
    active
    code
    iblock {
      code
    }
    seo {
      elementPageTitle
      elementMetaDescription
    }
    propertyValues {
      property {
        code
      }
      value
    }
    propertyValuesRelation(
      where: {OR: [{property: {type: FILE}}, {targetElement: {iblock: {code: {equals: "sectionProductHero"}}}}]}
    ) {
      property {
        code
        type
        kind
      }
      targetFile {
        url
        size
        contentType
      }
      targetElement {
        iblock {
          name
          id
          code
        }
        propertyValues(where: {property: {code: {equals: "text"}}}) {
          value
        }
      }
    }
  }
  elementsCount(
    where: {iblock: {code: {equals: $searchCategory}}, propertyValues: {none: {value: {contains: "noindex, nofollow"}}}, AND: [{propertyValuesEnum: {none: {property: {OR: [{code: {equals: "hiddenPage"}}, {code: {equals: "uniquePages"}}]}}}}, {OR: [{AND: [{name: {contains: $searchString}}, {iblock: {code: {equals: $searchCategory}}}]}, {AND: [{propertyValues: {some: {value: {contains: $searchString}}}}, {iblock: {OR: [{code: {equals: "document"}}, {code: {equals: "rgs_news"}}]}}]}, {propertyValuesRelation: {some: {targetElement: {AND: [{iblock: {code: {equals: "sectionProductHero"}}}, {propertyValues: {some: {value: {contains: $searchString}}}}]}}}}]}]}
  )
}
    `;

/**
 * __useSearchQueryQuery__
 *
 * To run a query within a Vue component, call `useSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchQueryQuery({
 *   searchString: // value for 'searchString'
 *   searchCategory: // value for 'searchCategory'
 *   first: // value for 'first'
 *   after: // value for 'after'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useSearchQueryQuery(variables: SearchQueryQueryVariables | VueCompositionApi.Ref<SearchQueryQueryVariables> | ReactiveFunction<SearchQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<SearchQueryQuery, SearchQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchQueryQuery, SearchQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchQueryQuery, SearchQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchQueryQuery, SearchQueryQueryVariables>(SearchQueryDocument, variables, options);
}
export type SearchQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchQueryQuery, SearchQueryQueryVariables>;
export const SitemapDocument = gql`
    query sitemap {
  settings: elements(where: {iblock: {code: {equals: "siteSettings"}}}) {
    id
    name
    code
    propertyValuesRelation(where: {property: {code: {equals: "mainSection"}}}) {
      property {
        code
      }
      targetSection {
        code
        name
      }
    }
  }
  seoAuto: elements(where: {iblock: {code: {equals: "seo-auto"}}}) {
    id
    code
    name
    updatedAt
    propertyValuesRelation {
      property {
        code
      }
      targetElement {
        code
        name
        propertyValuesRelation {
          property {
            code
          }
          targetElement {
            code
            name
            updatedAt
          }
        }
      }
    }
  }
  seoRegion: elements(where: {iblock: {code: {equals: "seo-region"}}}) {
    id
    code
    name
    updatedAt
  }
  seoCountry: elements(where: {iblock: {code: {equals: "seo-countries"}}}) {
    id
    code
    name
    updatedAt
  }
  seoRisks: elements(where: {iblock: {code: {equals: "seo-risks"}}}) {
    id
    code
    name
    updatedAt
  }
  seoSports: elements(where: {iblock: {code: {equals: "seo-sports"}}}) {
    id
    code
    name
    updatedAt
  }
  seoDevelopers: elements(where: {iblock: {code: {equals: "seo-developer"}}}) {
    id
    code
    name
    updatedAt
  }
  sections(where: {iblock: {code: {equals: "pageConstructor"}}}) {
    id
    name
    code
    level
    parentSection {
      id
      level
      code
    }
    childSections {
      id
      code
      level
    }
    elements(
      where: {iblock: {code: {equals: "pageConstructor"}}, propertyValues: {none: {value: {contains: "noindex"}}}}
    ) {
      id
      name
      code
      updatedAt
      propertyValues {
        property {
          code
        }
        value
      }
      propertyValuesEnum(where: {property: {code: {equals: "uniquePages"}}}) {
        property {
          code
        }
        value
      }
    }
  }
  leads: elements(where: {iblock: {code: {equals: "blockLead"}}}) {
    id
    code
    name
    updatedAt
  }
}
    `;

/**
 * __useSitemapQuery__
 *
 * To run a query within a Vue component, call `useSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSitemapQuery();
 */
export function useSitemapQuery(options: VueApolloComposable.UseQueryOptions<SitemapQuery, SitemapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SitemapQuery, SitemapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SitemapQuery, SitemapQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SitemapQuery, SitemapQueryVariables>(SitemapDocument, {}, options);
}
export type SitemapQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SitemapQuery, SitemapQueryVariables>;
export const SitemapNewsQueryDocument = gql`
    query sitemapNewsQuery {
  news: elements(
    where: {iblock: {code: {equals: "rgs_news"}}, propertyValues: {none: {value: {contains: "noindex"}}}}
  ) {
    code
    name
    updatedAt
  }
}
    `;

/**
 * __useSitemapNewsQueryQuery__
 *
 * To run a query within a Vue component, call `useSitemapNewsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapNewsQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSitemapNewsQueryQuery();
 */
export function useSitemapNewsQueryQuery(options: VueApolloComposable.UseQueryOptions<SitemapNewsQueryQuery, SitemapNewsQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SitemapNewsQueryQuery, SitemapNewsQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SitemapNewsQueryQuery, SitemapNewsQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SitemapNewsQueryQuery, SitemapNewsQueryQueryVariables>(SitemapNewsQueryDocument, {}, options);
}
export type SitemapNewsQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SitemapNewsQueryQuery, SitemapNewsQueryQueryVariables>;
export const SitemapCareerQueryDocument = gql`
    query sitemapCareerQuery {
  vacancies: elements(
    where: {iblock: {code: {equals: "vacancy"}}, propertyValues: {none: {value: {contains: "noindex"}}}}
  ) {
    code
    name
    updatedAt
  }
}
    `;

/**
 * __useSitemapCareerQueryQuery__
 *
 * To run a query within a Vue component, call `useSitemapCareerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitemapCareerQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSitemapCareerQueryQuery();
 */
export function useSitemapCareerQueryQuery(options: VueApolloComposable.UseQueryOptions<SitemapCareerQueryQuery, SitemapCareerQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SitemapCareerQueryQuery, SitemapCareerQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SitemapCareerQueryQuery, SitemapCareerQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SitemapCareerQueryQuery, SitemapCareerQueryQueryVariables>(SitemapCareerQueryDocument, {}, options);
}
export type SitemapCareerQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SitemapCareerQueryQuery, SitemapCareerQueryQueryVariables>;
export const TestQuestionDocument = gql`
    query testQuestion($where: ElementWhereInput) {
  elements(where: $where) {
    id
    name
    iblock {
      code
    }
    activeFrom
    sort
    code
    propertyValues {
      property {
        code
      }
      value
    }
    propertyValuesEnum {
      property {
        code
      }
      value
    }
    propertyValuesRelation {
      property {
        code
      }
      id
      targetElement {
        iblock {
          code
        }
        activeFrom
        sort
        code
        id
        name
        propertyValues {
          property {
            code
          }
          value
        }
        propertyValuesEnum {
          property {
            code
          }
          value
        }
        propertyValuesRelation {
          property {
            code
          }
          targetElement {
            iblock {
              code
            }
            activeFrom
            sort
            code
            id
            name
            propertyValues {
              property {
                code
              }
              value
            }
            propertyValuesEnum {
              property {
                code
              }
              value
            }
            propertyValuesRelation {
              property {
                code
              }
              targetElement {
                id
                name
                iblock {
                  code
                }
                activeFrom
                sort
                code
                propertyValuesEnum {
                  property {
                    code
                  }
                  value
                }
                propertyValues {
                  property {
                    code
                  }
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTestQuestionQuery__
 *
 * To run a query within a Vue component, call `useTestQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestQuestionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTestQuestionQuery({
 *   where: // value for 'where'
 * });
 */
export function useTestQuestionQuery(variables: TestQuestionQueryVariables | VueCompositionApi.Ref<TestQuestionQueryVariables> | ReactiveFunction<TestQuestionQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TestQuestionQuery, TestQuestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TestQuestionQuery, TestQuestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TestQuestionQuery, TestQuestionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TestQuestionQuery, TestQuestionQueryVariables>(TestQuestionDocument, variables, options);
}
export type TestQuestionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TestQuestionQuery, TestQuestionQueryVariables>;
export const GetVacanciesDocument = gql`
    query getVacancies($filter: ElementWhereInput, $first: Int) {
  elementsCount(where: $filter)
  elements(first: $first, where: $filter, orderBy: {createdAt: desc}) {
    name
    code
    createdAt
    propertyValues {
      value
      id
      property {
        name
        code
      }
    }
    propertyValuesRelation {
      property {
        code
      }
      targetElement {
        name
      }
    }
  }
}
    `;

/**
 * __useGetVacanciesQuery__
 *
 * To run a query within a Vue component, call `useGetVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacanciesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetVacanciesQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 * });
 */
export function useGetVacanciesQuery(variables: GetVacanciesQueryVariables | VueCompositionApi.Ref<GetVacanciesQueryVariables> | ReactiveFunction<GetVacanciesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetVacanciesQuery, GetVacanciesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetVacanciesQuery, GetVacanciesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetVacanciesQuery, GetVacanciesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetVacanciesQuery, GetVacanciesQueryVariables>(GetVacanciesDocument, variables, options);
}
export type GetVacanciesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetVacanciesQuery, GetVacanciesQueryVariables>;